/** Pull a readable string out of Motzu API JSON (`error.message` or `message`). */
export function apiErrorMessage(payload: unknown, fallback: string, status?: number): string {
  if (payload && typeof payload === 'object') {
    const data = payload as { message?: unknown; error?: unknown };
    if (typeof data.message === 'string' && data.message.trim()) return data.message;
    if (typeof data.error === 'string' && data.error.trim()) return data.error;
    if (data.error && typeof data.error === 'object') {
      const nested = (data.error as { message?: unknown }).message;
      if (typeof nested === 'string' && nested.trim()) return nested;
    }
  }
  return status ? `${fallback} (HTTP ${status})` : fallback;
}
